var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bug-report"},[_c('span',{staticClass:"text"},[_vm._v("משהו נראה לא נכון?")]),_vm._v(" "),_c('span',{staticClass:"link",on:{"click":function($event){return _vm.action()}}},[_vm._v("דווחו כאן על תקלה")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea06495e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/card-parts/CardBugReport.vue
// module id = null
// module chunks = 